"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmationModal = ConfirmationModal;

var _button = require("../buttons/button");

var _flatButton = require("../buttons/flat-button");

var _modal = require("./modal");

var _i18n = require("@slyk/i18n");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _excluded = ["cancelButtonLabel", "children", "confirmButtonLabel", "disabled", "isLoading", "onCancel", "onConfirm"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * `StyledButton` styled component.
 */
var StyledButton = (0, _styledComponents["default"])(_button.Button).withConfig({
  displayName: "confirmation-modal__StyledButton",
  componentId: "sc-p1rzf8-0"
})(["margin-bottom:16px;"]);
/**
 * Export `ConfirmationModal` component.
 */

function ConfirmationModal(props) {
  var cancelButtonLabel = props.cancelButtonLabel,
      children = props.children,
      confirmButtonLabel = props.confirmButtonLabel,
      disabled = props.disabled,
      isLoading = props.isLoading,
      onCancel = props.onCancel,
      onConfirm = props.onConfirm,
      rest = _objectWithoutProperties(props, _excluded);

  var _useTranslate = (0, _i18n.useTranslate)(),
      translate = _useTranslate.translate;

  return /*#__PURE__*/_react["default"].createElement(_modal.Modal, rest, children, /*#__PURE__*/_react["default"].createElement(StyledButton, {
    disabled: disabled,
    fullWidth: true,
    isLoading: isLoading,
    onClick: onConfirm,
    size: 'large',
    type: 'button'
  }, confirmButtonLabel || translate('common.actions.confirm')), /*#__PURE__*/_react["default"].createElement(_flatButton.FlatButton, {
    fullWidth: true,
    onClick: onCancel,
    size: 'large'
  }, cancelButtonLabel || translate('common.actions.cancel')));
}